import styled from 'styled-components';

export const CurrentBenefitsCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 249px;
  height: 235px;
  border-radius: 4px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 5px 20px #00000029;
`;

export const CardImgContainer = styled.div`
  display: flex;
  flex-grow: 2;

  background-position: center;
  height: 110px;
  width: 249px;
  border-radius: 4px 4px 0 0;
`;

export const FallbackImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px 4px 0 0;
`;

export const IconCardSlot = styled.div`
  display: flex;
  width: 35px;
  height: 36px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 5px;
  margin-top: 9px;
  cursor: pointer;
`;

export const IconSlot = styled.div`
  align-self: center;
  margin-top: 3px;
  svg {
    fill: #fff;
    height: auto;
  }
`;

export const CardContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-left: 15px;
  background: transparent linear-gradient(180deg, #ffffff 0%, #ffffff 100%) 0% 0% no-repeat padding-box;
  border-radius: 0px 0px 4px 4px;
`;

export const CardContentTitle = styled.p`
  font-size: 18px;
  color: #1c1b3a;
  font-weight: 600;
  margin-top: 21px;
  margin-bottom: 10px;
`;

export const CardContentSubTitle = styled.p`
  font-size: 14px;
  color: #1c1b3a;
  font-weight: 400;
  margin-top: 0%;
  margin-bottom: -3%;
`;

export const CardContentDate = styled.p`
  margin: 0;
  font-size: 16px;
  color: #1c1b3a;
  font-weight: 600;
  min-height: 22px;
`;

export const CardContentFee = styled.p`
  margin: 0;
  font-size: 16px;
  color: #0b9500;
  font-weight: 600;
`;
